import PropTypes from "prop-types";

const UserCell = ({ row }) => {
  const { firstName, lastName, middleName } = row.original;
  const name =
    `${firstName || ""} ${middleName || ""} ${lastName || ""}`.trim();

  return name;
};

UserCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      firstName: PropTypes.string,
      middleName: PropTypes.string,
      lastName: PropTypes.string
    }).isRequired
  }).isRequired
};

export const COLUMNS = [
  {
    Header: "Customer Name",
    Footer: "Customer Name",
    accessor: "displayName"
  },
  {
    Header: "User",
    Footer: "User",
    accessor: "lastName",
    Cell: UserCell
  },
  {
    Header: "Email",
    Footer: "Email",
    accessor: "primaryEmail"
  }
];
